var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlayIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 14C28 17.713 26.525 21.274 23.8995 23.8995C21.274 26.525 17.713 28 14 28C10.287 28 6.72601 26.525 4.10051 23.8995C1.475 21.274 0 17.713 0 14C0 10.287 1.475 6.72601 4.10051 4.10051C6.72601 1.475 10.287 0 14 0C17.713 0 21.274 1.475 23.8995 4.10051C26.525 6.72601 28 10.287 28 14ZM11.8825 8.91275C11.7517 8.8196 11.5977 8.76425 11.4375 8.75278C11.2773 8.7413 11.117 8.77414 10.9743 8.8477C10.8315 8.92126 10.7117 9.03269 10.6281 9.1698C10.5444 9.3069 10.5001 9.46439 10.5 9.625V18.375C10.5001 18.5356 10.5444 18.6931 10.6281 18.8302C10.7117 18.9673 10.8315 19.0787 10.9743 19.1523C11.117 19.2259 11.2773 19.2587 11.4375 19.2472C11.5977 19.2358 11.7517 19.1804 11.8825 19.0872L18.0075 14.7122C18.1209 14.6313 18.2134 14.5244 18.2772 14.4006C18.341 14.2767 18.3742 14.1393 18.3742 14C18.3742 13.8607 18.341 13.7233 18.2772 13.5994C18.2134 13.4756 18.1209 13.3687 18.0075 13.2878L11.8825 8.91275Z",
    fill: "#0EC99E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIconActive);
export default __webpack_public_path__ + "static/media/playIconActive.ca2ea5569f0d587724adf54d9134f12f.svg";
export { ForwardRef as ReactComponent };